import React from 'react';
import {
  Box,
  Typography,
  Container,
  Link as MuiLink,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        background: 'rgba(18, 18, 18, 0.95)',
        minHeight: '100vh',
        color: 'white',
        pt: { xs: 10, sm: 12 },
        pb: 4,
      }}
    >
      <Container
        maxWidth="md"
        sx={{
          px: { xs: 2, sm: 3 },
          py: 4,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 300,
            mb: 2,
            letterSpacing: '0.05em',
            color: '#2196F3',
          }}
        >
          {t('privacy.title')}
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.7)', mb: 2 }}
        >
          {t('privacy.lastUpdated')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.intro1')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('privacy.intro2')}
          <MuiLink
            href="https://www.privacypolicies.com/privacy-policy-generator/"
            target="_blank"
            rel="nofollow noopener"
            sx={{ color: '#2196F3', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
          >
            {t('privacy.privacyPolicyGenerator')}
          </MuiLink>
          .
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('privacy.interpretationTitle')}
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('privacy.interpretation')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.interpretationText')}
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('privacy.definitions')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 1 }}
        >
          {t('privacy.definitionsIntro')}
        </Typography>
        <List sx={{ pl: 2, mb: 4, listStyleType: 'disc', display: 'list-item' }}>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.definitionsAccountTerm')}</strong>{' '}
                  {t('privacy.definitionsAccount')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.definitionsAffiliateTerm')}</strong>{' '}
                  {t('privacy.definitionsAffiliate')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.definitionsCompanyTerm')}</strong>{' '}
                  {t('privacy.definitionsCompany')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.definitionsCookiesTerm')}</strong>{' '}
                  {t('privacy.definitionsCookies')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.definitionsCountryTerm')}</strong>{' '}
                  {t('privacy.definitionsCountry')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.definitionsDeviceTerm')}</strong>{' '}
                  {t('privacy.definitionsDevice')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.definitionsPersonalDataTerm')}</strong>{' '}
                  {t('privacy.definitionsPersonalData')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.definitionsServiceTerm')}</strong>{' '}
                  {t('privacy.definitionsService')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.definitionsServiceProviderTerm')}</strong>{' '}
                  {t('privacy.definitionsServiceProvider')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.definitionsUsageDataTerm')}</strong>{' '}
                  {t('privacy.definitionsUsageData')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.definitionsWebsiteTerm')}</strong>{' '}
                  {t('privacy.definitionsWebsite')}
                  <MuiLink
                    href="https://aerocycling-project-front.onrender.com/"
                    target="_blank"
                    rel="external nofollow noopener"
                    sx={{ color: '#2196F3', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                  >
                    https://aerocycling-project-front.onrender.com/
                  </MuiLink>
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.definitionsYouTerm')}</strong>{' '}
                  {t('privacy.definitionsYou')}
                </Typography>
              }
            />
          </ListItem>
        </List>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('privacy.userRegistrationTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('privacy.userRegistration')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('privacy.dataStorageTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('privacy.dataStorage')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('privacy.collectingTitle')}
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('privacy.typesTitle')}
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('privacy.personalDataTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 1 }}
        >
          {t('privacy.personalDataText')}
        </Typography>
        <List sx={{ pl: 2, mb: 2, listStyleType: 'disc', display: 'list-item' }}>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  {t('privacy.personalDataEmail')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  {t('privacy.personalDataUsage')}
                </Typography>
              }
            />
          </ListItem>
        </List>
        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('privacy.usageDataTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.usageData1')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.usageData2')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.usageData3')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.usageData4')}
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('privacy.trackingTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 1 }}
        >
          {t('privacy.tracking1')}
        </Typography>
        <List sx={{ pl: 2, mb: 2, listStyleType: 'disc', display: 'list-item' }}>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.trackingCookies')}</strong>
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.trackingBeacons')}</strong>
                </Typography>
              }
            />
          </ListItem>
        </List>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.tracking2')}
          <MuiLink
            href="https://www.privacypolicies.com/blog/privacy-policy-template/#Use_Of_Cookies_Log_Files_And_Tracking"
            target="_blank"
            rel="nofollow noopener"
            sx={{ color: '#2196F3', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
          >
            {t('privacy.trackingLinkText')}
          </MuiLink>
          {' '}article.
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 1 }}
        >
          {t('privacy.tracking3')}
        </Typography>
        <List sx={{ pl: 2, mb: 4, listStyleType: 'disc', display: 'list-item' }}>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.necessaryCookiesTitle')}</strong>
                  <br />
                  {t('privacy.necessaryCookiesType')}
                  <br />
                  {t('privacy.necessaryCookiesAdmin')}
                  <br />
                  {t('privacy.necessaryCookiesPurpose')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.acceptanceCookiesTitle')}</strong>
                  <br />
                  {t('privacy.acceptanceCookiesType')}
                  <br />
                  {t('privacy.acceptanceCookiesAdmin')}
                  <br />
                  {t('privacy.acceptanceCookiesPurpose')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.functionalityCookiesTitle')}</strong>
                  <br />
                  {t('privacy.functionalityCookiesType')}
                  <br />
                  {t('privacy.functionalityCookiesAdmin')}
                  <br />
                  {t('privacy.functionalityCookiesPurpose')}
                </Typography>
              }
            />
          </ListItem>
        </List>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('privacy.moreCookiesInfo')}
        </Typography>

        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('privacy.usePersonalDataTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 1 }}
        >
          {t('privacy.usePersonalDataIntro')}
        </Typography>
        <List sx={{ pl: 2, mb: 4, listStyleType: 'disc', display: 'list-item' }}>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.usePersonalData1')}</strong>
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.usePersonalData2')}</strong>
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.usePersonalData3')}</strong>
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.usePersonalData4')}</strong>
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.usePersonalData5')}</strong>
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.usePersonalData6')}</strong>
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.usePersonalData7')}</strong>
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.usePersonalData8')}</strong>
                </Typography>
              }
            />
          </ListItem>
        </List>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 1 }}
        >
          {t('privacy.sharePersonalDataIntro')}
        </Typography>
        <List sx={{ pl: 2, mb: 4, listStyleType: 'disc', display: 'list-item' }}>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.sharePersonalData1')}</strong>
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.sharePersonalData2')}</strong>
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.sharePersonalData3')}</strong>
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.sharePersonalData4')}</strong>
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.sharePersonalData5')}</strong>
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  <strong>{t('privacy.sharePersonalData6')}</strong>
                </Typography>
              }
            />
          </ListItem>
        </List>

        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('privacy.retentionTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.retention1')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('privacy.retention2')}
        </Typography>

        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('privacy.transferTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.transfer1')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.transfer2')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('privacy.transfer3')}
        </Typography>

        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('privacy.deleteTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.delete1')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.delete2')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.delete3')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('privacy.delete4')}
        </Typography>

        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('privacy.disclosureTitle')}
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('privacy.businessTransactionsTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.businessTransactions')}
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('privacy.lawEnforcementTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.lawEnforcement')}
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('privacy.otherLegalTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 1 }}
        >
          {t('privacy.otherLegalIntro')}
        </Typography>
        <List sx={{ pl: 2, mb: 4, listStyleType: 'disc', display: 'list-item' }}>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  {t('privacy.otherLegal1')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  {t('privacy.otherLegal2')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  {t('privacy.otherLegal3')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  {t('privacy.otherLegal4')}
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  {t('privacy.otherLegal5')}
                </Typography>
              }
            />
          </ListItem>
        </List>

        <Typography
          variant="h6"
          sx={{ fontWeight: 300, mb: 1, color: 'rgba(255, 255, 255, 0.9)' }}
        >
          {t('privacy.securityTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('privacy.security')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('privacy.childrenTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.children1')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('privacy.children2')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('privacy.linksTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.links1')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('privacy.links2')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('privacy.changesTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.changes1')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 2 }}
        >
          {t('privacy.changes2')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 4 }}
        >
          {t('privacy.changes3')}
        </Typography>

        <Typography
          variant="h5"
          sx={{ fontWeight: 300, mb: 2, color: '#2196F3' }}
        >
          {t('privacy.contactTitle')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)', mb: 1 }}
        >
          {t('privacy.contactIntro')}
        </Typography>
        <List sx={{ pl: 2, mb: 4, listStyleType: 'disc', display: 'list-item' }}>
          <ListItem sx={{ display: 'list-item', pl: 1 }}>
            <ListItemText
              primary={
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 300, color: 'rgba(255, 255, 255, 0.9)' }}
                >
                  {t('privacy.contactEmail')}
                </Typography>
              }
            />
          </ListItem>
        </List>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;